export default "__VITE_ASSET__BtcEsGok__"